import { IBaseContact } from '../contacts/IBaseContact';
import { IPresentationContactData } from '../contacts/IPresentationContactData';

export interface IClientUserResponse extends IBaseContact<string> {
  active: boolean;
  invitationSentAt?: string;
  activatedBy?: string;
  activatedAt?: string;
  deactivatedBy?: string;
  deactivatedAt?: string;
  companyName: string;
  phoneNumber: string;
  email: string;
}

export type IClientUserData = IClientUserResponse;

export const convertFromClientUserResponseToClientUserData = (data: IClientUserResponse): IClientUserData => data;
export const convertFromClientUserDataToClientUserResponse = (data: IClientUserData): IClientUserResponse => data;

export const convertFromClientUserResponseArrayToClientUserDataArray = (
  data: IClientUserResponse[]
): IClientUserData[] => data;

export type IPresentationClientUserData = IPresentationContactData<IClientUserData, string>;
